const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持1080P与4K超清播放，自适应码率确保流畅度，每一帧都清晰细腻，带来影院级视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '与各大平台同步更新，热播新剧播出后2小时内上线，院线大片下映最快一周收录，追剧不等待。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '电脑、平板、手机全端覆盖，支持投屏至电视大屏，随时随地畅享高清观影，一个浏览器就够了。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '安全纯净',
    desc: '无弹窗广告、无恶意跳转、无强制注册，纯净观影环境，保护您的隐私和上网安全。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库',
    desc: '收录超过两万部影视资源，涵盖动作、悬疑、爱情、喜剧、科幻、动漫等全类型，持续扩充中。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-accent-400 mb-3">WHY US</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">平台优势</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">为什么选择成全影院？五大核心优势给你答案</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {features.map((f, i) => (
              <div key={i} className="group bg-background-100 rounded-xl p-6 border border-background-200/40 hover:border-primary-500/20 transition-all duration-300 hover:bg-background-200/60">
                <div className="w-12 h-12 rounded-lg bg-primary-500/10 flex items-center justify-center mb-5 group-hover:bg-primary-500/20 transition-colors duration-300">
                  <i className={`${f.icon} text-xl text-primary-400`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-3">{f.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}